import ApiService from "../api";

export default class ClientService extends ApiService {

    constructor() {
        super('/api/clients');
    }

    findById(id) {
        return this.get(`/${id}`);
    }

    
    findByCode(code) {
        return this.get(`/code/${code}`);
    }

    findAll(filter, pageSize, page) {
        let params = `?size=${pageSize}&page=${page}`

        if (filter.name) {
            params = `${params}&name=${filter.name}`
        }

        if (filter.code) {
            params = `${params}&code=${filter.code}`
        }

        if (filter.addressCity) {
            params = `${params}&addressCity=${filter.addressCity}`
        }

        if (filter.branchId) {
            params = `${params}&branchId=${filter.branchId}`
        }

        if (filter.branchCode) {
            params = `${params}&branchCode=${filter.branchCode}`
        }

        return this.get(`${params}`,); // suporte a paginação e filtro
    }

    create(client) {
        return this.post('/', client);
    }

    update(id, client) {
        return this.put(`/${id}`, client);
    }

    del(id) {
        return this.delete(`/${id}`);
    }

    importFileClient(branchId, atualiza, formData) {
        return this.post(`/import-clients/branch/${branchId}/${atualiza}`, formData);
    }
}


